PegasusTemplate.BlockRegistrarMixin = Em.Mixin.create({
  didDeleteBlock: function(block){
    if ( this.get('parentView') && this.get('parentView').didDeleteBlock ){
      this.get('parentView').didDeleteBlock(block);
    }
  },

  didCreatePaddingCell: function(cell, orientation){
    if ( this.get('parentView') && this.get('parentView').didCreatePaddingCell){
      this.get('parentView').didCreatePaddingCell(cell, orientation);
    }
  },

  didCreateBackgroundImageCell: function(cell){
    if ( this.get('parentView') && this.get('parentView').didCreateBackgroundImageCell){
      this.get('parentView').didCreateBackgroundImageCell(cell);
    }
  },

  didCreateMirrorCapable: function(element) {
    if ( this.get('parentView') && this.get('parentView').didCreateMirrorCapable) {
      this.get('parentView').didCreateMirrorCapable(element);
    }
  },

  didCreateColumnSpacer: function(cell, orientation) {
    if ( this.get('parentView') && this.get('parentView').didCreateColumnSpacer) {
      this.get('parentView').didCreateColumnSpacer( cell, orientation );
    }
  },
});
